<script setup lang="ts">
import CandidatesHeader from "@/components/marketing/candidates/CandidatesHeader.vue";
import CandidatesHowItWorks from "@/components/marketing/candidates/CandidatesHowItWorks.vue";
import CandidatesPlatformFeatures from "@/components/marketing/candidates/CandidatesPlatformFeatures.vue";
import CandidatesFAQ from "@/components/marketing/candidates/CandidatesFAQ.vue";
import CallToAction from "@/components/marketing/CallToAction.vue";
import FooterCTABar from "@/components/marketing/FooterCTABar.vue";

const data = await useSeoAndGetContent(ROUTES.candidates);
const { header, features, platformFeatures, socialProof, faq, callToAction, footerCTA } = data;

definePageMeta({
  layout: "marketing",
});
</script>

<template>
  <div class="relative bg-warm-white overflow-x-hidden">
    <div class="flex flex-col">
      <CandidatesHeader :content="header" />
      <CandidatesHowItWorks :content="features" />
      <CandidatesPlatformFeatures :content="platformFeatures" />
      <CandidatesFAQ :content="faq" />
      <CallToAction :content="callToAction" variant="candidates" />
      <FooterCTABar :content="footerCTA" />
    </div>
  </div>
</template>
